<template>
  <div
    class="introduction-root no-head-height"
    v-track="{
      act: 'show',
      params: { cfrom: '01|01|078|001', type: type }
    }"
  >
    <div class="banner">
      <div class="banner-img">
        <picture>
          <source
            v-if="bannerContent[type].image2"
            :srcset="bannerContent[type].image2"
            media="screen and (max-width: 527px)"
          />
          <img :src="bannerContent[type].image" alt="banner" />
        </picture>
      </div>
      <div class="banner-text">
        <h2 class="service-name os-font-24-400">{{ bannerContent[type].title }}</h2>
      </div>
    </div>
    <holidayTips></holidayTips>
    <div class="service-process">
      <!--  经过测试，在新机型和系统上，系统会自动反色图标，使用两套图标反而会和系统反色冲突，因此去除深色模式图标 - 2024/03/06   -->
      <div v-if="type === 6" class="quick-type">
        <div>
          <img
            class="icon"
            :src="require('@/assets/img/introduction/wap/banner-icon/icon10.png')"
            alt="icon"
          />
          <p class="os-font-14-500">最快4小时送返</p>
          <span class="os-font-12-400">从下单到修复送返，最快4小时取回设备</span>
        </div>
        <div>
          <img
            class="icon"
            :src="require('@/assets/img/introduction/wap/banner-icon/icon11.png')"
            alt="icon"
          />
          <p class="os-font-14-500">官方一站式服务</p>
          <span class="os-font-12-400">取送+检修一站式服务，省力更省心</span>
        </div>
      </div>
      <p v-else class="os-font-18-500">服务流程</p>
      <ul>
        <li v-for="(item, index) in serviceProcess[type]" :key="index">
          <img class="icon" :src="item.imageUrl" alt="icon" />
          <p class="os-font-10-400">{{ item.title }}</p>
        </li>
      </ul>
      <div>
        <a :class="['service-btn-1 os-font-16-400', { disabled: holidayIsValid }]" @click="goNext"
          >立即申请</a
        >
        <a
          :class="['service-btn-2 os-font-12-500', { disabled: holidayIsValid }]"
          v-if="type === 2 && isWeChatApp"
          @click="goDealerRepair"
          >经销商寄修</a
        >
      </div>
    </div>
    <commonTips :positionKey="positionKey"></commonTips>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import commonTips from '@/views/repair/base/wap/components/common-tips/index.vue'
import holidayTips from '@/views/repair/introduction/components/holiday-tips/index.vue'
import axios from 'axios'
import env from 'utils/clientEnv'

export default {
  name: 'repairIntroduction',
  components: {
    commonTips,
    holidayTips
  },
  data() {
    return {
      needLogin: false,
      bannerTitle: '',
      bannerImg: require('assets/img/introduction/wap/banner-appointment.png'),
      type: 0,
      beginTime: +new Date(),
      serviceProcess: {
        // 预约
        1: [
          {
            title: '在线预约',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon1.png')
          },
          {
            title: '按时到店',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon2.png')
          },
          {
            title: '扫码签到',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon3.png')
          },
          {
            title: '品质维修',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon4.png')
          },
          {
            title: '安心用机',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon5.png')
          }
        ],
        // 寄修
        2: [
          {
            title: '在线报修',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon1.png')
          },
          {
            title: '上门取件',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon6.png')
          },
          {
            title: '品质维修',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon4.png')
          },
          {
            title: '顺丰寄回',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon7.png')
          },
          {
            title: '安心用机',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon5.png')
          }
        ],
        // 上门
        3: [
          {
            title: '在线报修',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon1.png')
          },
          {
            title: '极速上门',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon6.png')
          },
          {
            title: '品质维修',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon4.png')
          },
          {
            title: '现场处理',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon8.png')
          },
          {
            title: '安心用机',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon5.png')
          }
        ],
        // 同城
        6: [
          {
            title: '在线报修',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon1.png')
          },
          {
            title: '上门取件',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon6.png')
          },
          {
            title: '品质维修',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon4.png')
          },
          {
            title: '送机上门',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon9.png')
          },
          {
            title: '安心用机',
            imageUrl: require('assets/img/introduction/wap/banner-icon/icon5.png')
          }
        ]
      },
      bannerContent: {
        1: {
          title: '预约服务',
          image: require('assets/img/introduction/wap/banner-appointment.png')
        },
        2: {
          title: '寄修服务',
          image: require('assets/img/introduction/wap/banner-post.png')
        },
        3: {
          title: '上门维修',
          image: require('assets/img/introduction/wap/banner-home.png')
        },
        6: {
          title: '同城快修',
          image: require('assets/img/introduction/wap/banner-city.png'),
          image2: require('assets/img/introduction/wap/banner-city-1.png')
        }
      }
    }
  },
  computed: {
    ...mapState('repair', ['holidayIsValid', 'isWeChatApp', 'repairType']),
    ...mapState(['isDarkMode']),
    positionKey() {
      switch (this.type) {
        case 1:
          return 'store_start_tips'
        case 2:
          return 'send_start_tips'
        case 3:
          return 'home_start_tips'
        case 6:
          return 'run_start_tips'
        default:
          return ''
      }
    }
  },
  created() {
    // 老页面链接兼容
    const pathUrl = window.location.pathname
    // 同城快修介绍页
    if (
      this.repairType &&
      (this.repairType === 1 ||
        this.repairType === 2 ||
        this.repairType === 3 ||
        this.repairType === 6)
    ) {
      this.type = this.repairType
    } else if (pathUrl === '/service/quick-pickup/introduction') {
      this.type = 6
      this.SET_REPAIR_TYPE(this.type)
      // 寄修介绍页
    } else if (pathUrl === '/service/repair/introduce') {
      this.type = 2
      this.SET_REPAIR_TYPE(this.type)
      // 预约
    } else if (pathUrl === '/service/appointment') {
      if (this.$route.query.from === 'support') {
        this.SET_FROM_SUPPORT(true)
      }
      this.type = 1
      this.SET_REPAIR_TYPE(this.type)
      // 寄修/同城快修 根据 orderType 识别
    } else if (pathUrl === '/service/repair/send-repair/index') {
      if (this.$route.query.from === 'support') {
        this.SET_FROM_SUPPORT(true)
      }
      const orderType = this.$route.query.orderType
      if (orderType && String(orderType) === '6') {
        this.type = 6
      } else {
        this.type = 2
      }
      this.SET_REPAIR_TYPE(this.type)
      // 上门维修
    } else if (pathUrl === '/service/home-repair/introduction') {
      this.type = 3
      this.SET_REPAIR_TYPE(this.type)
    } else {
      this.type = Number(this.$route.params.type)
      // 判断是否是四大维修
      if (this.type && (this.type === 1 || this.type === 2 || this.type === 3 || this.type === 6)) {
        this.SET_REPAIR_TYPE(this.type)
      } else {
        location.href = 'https://www.vivo.com.cn/404'
      }
    }
    this.setTitle()

    // 检查登录态
    this.needLogin = false
    let devBaseUrl = ''
    let baseUrl = window.location.host.includes('vivo.com.cn')
      ? 'https://cust.vivo.com.cn'
      : 'https://cust.vivo.com'

    axios({
      url: `${process.env.NODE_ENV === 'production' ? baseUrl : devBaseUrl}/commonservice/sendtorepair/check/oldOrder`,
      method: 'post',
      withCredentials: true
    }).then(res => {
      this.needLogin = res.data && res.data.code === 600
    })
  },
  mounted() {},
  methods: {
    ...mapMutations('repair', ['SET_REPAIR_TYPE', 'SET_REPAIR_BEGIN_TIME', 'SET_FROM_SUPPORT']),
    setTitle() {
      setTimeout(() => {
        if (this.type == 1) {
          document.title = '预约服务'
        } else if (this.type == 2) {
          document.title = '寄修服务'
        } else if (this.type == 3) {
          document.title = '上门维修'
        } else if (this.type == 6) {
          document.title = '同城快修'
        }
      }, 50)
    },
    goDealerRepair() {
      if (this.isWeChatApp) {
        window.wx.miniProgram.navigateTo({
          url: '/modules/service/pagesSub/serveDealerRepair/dealerRepair/index'
        })
      }
    },
    goNext() {
      if (this.holidayIsValid) {
        return
      }

      // 上报埋点
      this.$track({
        cfrom: '01|03|078|003',
        type: this.type,
        duration: +new Date() - this.beginTime
      })
      this.SET_REPAIR_BEGIN_TIME(+new Date())

      // 跳转下一页或者登录页
      if (this.needLogin) {
        const host = `${window.location.protocol}//${window.location.host}`
        const url = `${host}/service/s/repair/base/${this.type}`
        if (env.isVivoApp) {
          // 如果是官网app,则调用app登录功能
          window.vivospace.login(url)
        } else {
          let targetUrl

          if (window.location.host.includes('vivo.com.cn')) {
            targetUrl = `https://passport.vivo.com.cn/v3/web/login/authorize?client_id=30&redirect_uri=${encodeURIComponent(url)}`
          } else {
            targetUrl = `https://passport.vivo.com/v3/web/login/authorize?client_id=30&redirect_uri=${encodeURIComponent(url)}`
          }

          window.location.replace(targetUrl)
        }
      } else {
        this.$router.push(`/service/s/repair/base/${this.type}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.introduction-root {
  padding-bottom: 40px;

  .no-head & {
    min-height: calc(100vh + 120px);
  }

  .banner {
    height: 360px;
    position: relative;
    overflow: hidden;

    .no-head & {
      margin-top: -120px;
    }

    .banner-img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      height: 360px;

      img {
        opacity: 1;
        transition: opacity 0.2s ease-in;
        height: 100%;
      }
    }

    .banner-text {
      position: relative;

      h2 {
        color: #242933;
        text-align: center;
        margin-top: 80px;
      }
    }
  }

  .service-process {
    position: relative;
    background-color: #fff;
    padding: 16px 16px 20px;
    border-radius: 12px;
    margin: -28px 16px 0;
    max-width: 664px;
    box-sizing: border-box;

    .vivo-dark-mode & {
      background-color: #f7f7f7;
    }

    @media screen and (min-width: 697px) {
      margin: -28px auto 0;
    }

    .quick-type {
      display: flex;
      justify-content: space-between;
      padding-bottom: 24px;
      border-bottom: 1px solid #f0f2f5;
      margin-bottom: -4px;

      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        width: calc(50% - 8px);

        img {
          width: 24px;
          height: 24px;
        }

        p {
          margin-top: 6px;
          margin-bottom: 6px;
          color: #333;
          line-height: 18px;
        }

        span {
          color: #999;
          line-height: 15px;
        }
      }
    }

    > p {
      color: #333;
      text-align: center;
      line-height: 22px;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      position: relative;
      max-width: 488px;
      margin: 28px auto 43px;

      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: #ddd;
        left: 0;
        bottom: -10px;
      }

      li {
        display: flex;
        align-items: center;
        flex-direction: column;
        position: relative;

        &:first-of-type {
          &:before {
            content: '';
            position: absolute;
            background-color: #fff;
            height: 3px;
            left: 0;
            right: calc(50% + 3px);
            bottom: -12px;
            z-index: 1;

            .vivo-dark-mode & {
              background-color: #f7f7f7;
            }
          }
        }

        &:last-of-type {
          &:before {
            content: '';
            position: absolute;
            background-color: #fff;
            height: 3px;
            right: 0;
            left: calc(50% + 3px);
            bottom: -12px;
            z-index: 1;

            .vivo-dark-mode & {
              background-color: #f7f7f7;
            }
          }
        }

        &:after {
          content: '';
          position: absolute;
          width: 6px;
          height: 6px;
          bottom: -13px;
          left: 50%;
          transform: translateX(-50%);
          background-color: #ddd;
          border-radius: 3px;
        }

        img {
          width: 24px;
          height: 24px;
          margin-bottom: 5px;
        }

        p {
          color: #333;
          line-height: 13px;
        }
      }
    }

    div {
      font-size: 0;
      line-height: 1;

      .service-btn-1 {
        display: block;
        width: 264px;
        line-height: 46px;
        border-radius: 82px;
        color: #fff;
        text-align: center;
        margin: 0 auto;
        background-color: #415fff;

        .vivo-dark-mode & {
          background-color: #3a56e6;
        }
      }

      .service-btn-2 {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
        margin-top: 16px;
        line-height: 16px;

        &:after {
          content: '';
          width: 6px;
          height: 16px;
          background-image: url('data:image/svg+xml;base64,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');
          background-size: 100% 100%;
          margin-left: 3px;
        }
      }

      a.disabled {
        opacity: 0.3;
      }
    }
  }
}
</style>
